import { isNamanHowell } from "@/shared/utils/firm";

/**
 * Legal abbreviations for text expansion.
 * When a user types an abbreviation followed by a space, it expands to the full text.
 */
export const ABBREVIATIONS: Record<string, string> = {
  apar: "Appearance at and participation in",
  cf: "correspondence from",
  cfp: "counsel for plaintiffs",
  cmc: "Case Management Conference",
  cmo: "case management order",
  cmp: "case management plan",
  cms: "Case Management Statement",
  comms: "communications with",
  corr: "correspondence",
  cr: "claims representative",
  cra: "certificate regarding compulsory arbitration",
  ct: "correspondence to",
  cv: "curriculum vitae",
  cw: "correspondence with",
  cwc: "correspondence with client",
  cwoc: "correspondence with opposing counsel",
  dec: "Draft email correspondence to",
  decl: "declaration",
  depo: "deposition",
  dm: "Draft Motion",
  dmil: "Draft Motion in Limine",
  docs: "documents",
  drr: "Draft and revise",
  edw: "email discussion with",
  eoc: "exclusive of travel time",
  eott: "(exclusive of travel time)",
  era: "Extensive review and analysis of",
  ewd: "Expert Witness Designation",
  excont: "ex parte application to continue trial",
  fac: "First Amended Complaint",
  fh: "further handling",
  fpo: "for purposes of",
  frog: "form interrogatories",
  fsc: "Final Status Conference",
  gfs: "good faith settlement",
  idc: "informal discovery conference",
  ids: "initial disclosure statement",
  ime: "independent medical examination",
  ioc: "inclusive of travel time",
  info: "information",
  ipo: "in preparation of",
  iso: "in support of",
  itc: "length telephone conference with",
  mil: "Motion in Limine",
  msa: "Motion for Summary Adjudication",
  msc: "mandatory settlement conference",
  msj: "Motion for Summary Judgment",
  mtc: "Motion to Compel",
  nod: "Notice of Deposition",
  nui: "non-uniform interrogatories",
  oc: "opposing counsel",
  ost: "Order Shortening Time",
  pc: "plaintiff's counsel",
  pcs: "plaintiffs' counsel",
  plf: "plaintiff",
  plaitniff: "plaintiff",
  pmk: "person most knowledgeable",
  ra: "review and analysis of",
  raec: "Review and analysis of electronic correspondence",
  re: "regarding",
  rfa: "Request for Admissions",
  rfd: "request for dismissal",
  rfp: "Request for Production of Documents",
  sar: "Settlement & Release Agreement",
  sdt: "subpoena duces tecum",
  sof: "Statement of Facts",
  sow: "scope of work",
  sprog: "special interrogatories",
  tbi: "traumatic brain injury",
  tc: "telephone conference with",
  teh: "the",
  ui: "uniform interrogatories",
  vc: "video conference",
  wat: "with attention to",
};

export const NAMANHOWELL_ABBREVIATIONS: Record<string, string> = {
  ah: "Attend hearing",
  ansi: "answers to interrogatories",
  appl: "application",
  bk: "Bankruptcy",
  br: "brief",
  cc: "Conference Call",
  cf: "Review and analyze claim materials to determine strategy for initial handling and surgically creating leverage in the case with documents and information provided from Amica to aid in the defense of the client and formulation of strategy, including property damage documentation, photographs, estimates, correspondence, claim notes, internal correspondence, discussions with the client, opposing party, police report, investigative materials collected prior to the filing of suit. (approximately ___ pages)",
  ck: "Check",
  corr: "Correspondence",
  cv: "Curriculum Vitae",
  cw: "Conference with",
  dar: "Draft and review",
  docs: "documents",
  dps: "Department of Public Safety",
  dwq: "deposition on written questions",
  euo: "examination under oath",
  ev: "Evaluate",
  fnb: "Forum Non Conveniens",
  gl: "General Liability",
  hos: "Hospital",
  inv: "Investigation",
  irt: "in response to",
  lf: "Letter from",
  lt: "Letter to",
  msj: "motion for summary judgment",
  mtd: "Motion to Dismiss",
  mtv: "Motion to Transfer Venue",
  mw: "Meeting with",
  oc: "opposing counsel",
  od: "Oral deposition",
  phr: "Pharmacy Records",
  pr: "Prepare",
  prel: "preliminary",
  ra: "Review and analyze",
  raf: "Radiology Films",
  rar: "Radiology records of",
  rcf: "Review correspondence from",
  rct: "Review correspondence to",
  re: "regarding",
  rec: "Receive",
  rem: "Receive and review email",
  reva: "Review and evaluate",
  rfa: "Request for Admission",
  rfd: "Request for Disclosure",
  rfp: "Request for Production",
  rog: "interrogatory",
  rr: "Receive, review, and analyze",
  rrfa: "responses to requests for admission",
  rrfd: "responses to requests for disclosure",
  rrfp: "responses to requests for production",
  rs: "Research",
  rt: "Round trip",
  rv: "Review",
  tc: "Telephone conference",
  tcw: "Prepare for and conduct telephone conference with",
  td: "Take deposition of",
  tf: "Telephone call from",
  tr: "Trial",
  tsbm: "Texas State Board of Medical Examiners",
  tv: "Travel",
};

export function getAbbreviations(): Record<string, string> {
  if (isNamanHowell()) return NAMANHOWELL_ABBREVIATIONS;
  return ABBREVIATIONS;
}